var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDomainRank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_7015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.50195 13.8545H7.521",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98828 4.35449H17.0173",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50055 9.10449H0.404297",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00736 18.592C7.24767 18.495 5.55396 17.8893 4.13177 16.8485C2.70958 15.8077 1.62004 14.3765 0.995378 12.7286C0.370715 11.0806 0.23778 9.28682 0.612706 7.5648C0.987631 5.84279 1.8543 4.26661 3.10754 3.02753C4.36077 1.78846 5.9467 0.939761 7.67287 0.584432C9.39903 0.229102 11.1912 0.382416 12.832 1.02577C14.4727 1.66912 15.8914 2.77485 16.916 4.20878C17.9406 5.64271 18.5269 7.34319 18.6039 9.10387",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92102 0.417206C4.17102 5.56304 4.25731 12.259 9.00731 18.5923",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0781 0.417206C11.8521 2.26358 13.0299 4.60068 13.4585 7.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4145 9.44458L15.6321 12.2708H18.0071C18.1268 12.2663 18.245 12.2988 18.3455 12.364C18.4461 12.4291 18.524 12.5237 18.5688 12.6348C18.6136 12.7459 18.623 12.8681 18.5957 12.9848C18.5684 13.1014 18.5058 13.2068 18.4164 13.2865L16.3581 15.12L17.4981 17.7428C17.5481 17.8628 17.5593 17.9954 17.53 18.1221C17.5007 18.2487 17.4324 18.363 17.3348 18.4488C17.2372 18.5346 17.1151 18.5876 16.9858 18.6005C16.8564 18.6133 16.7263 18.5852 16.6138 18.5202L13.854 16.9678L11.0982 18.5202C10.9857 18.5852 10.8556 18.6133 10.7262 18.6005C10.5969 18.5876 10.4748 18.5346 10.3772 18.4488C10.2796 18.363 10.2113 18.2487 10.182 18.1221C10.1528 17.9954 10.1639 17.8628 10.2139 17.7428L11.3539 15.12L9.29561 13.2865C9.20568 13.207 9.14262 13.1015 9.11509 12.9846C9.08756 12.8677 9.09691 12.7452 9.14187 12.6338C9.18682 12.5225 9.26517 12.4278 9.36614 12.3628C9.4671 12.2978 9.58572 12.2657 9.70569 12.2708H12.0759L13.2999 9.44458C13.3541 9.34403 13.4346 9.26004 13.5327 9.20151C13.6308 9.14297 13.7429 9.11206 13.8572 9.11206C13.9714 9.11206 14.0836 9.14297 14.1817 9.20151C14.2798 9.26004 14.3603 9.34403 14.4145 9.44458Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_7015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainRank);
export default __webpack_public_path__ + "static/media/domain-rank.b7d5f4ead3c7940e8a4ffdda24d20fb1.svg";
export { ForwardRef as ReactComponent };